import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/logo.png';
import './Navbar.css';

const links = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Packages', href: '#packages' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLink = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.nav
      className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="navbar__inner container">
        {/* Logo */}
        <a href="#home" className="navbar__logo" onClick={() => handleLink('#home')}>
          <img src={logo} alt="RRP & Associates" />
        </a>

        {/* Desktop links */}
        <ul className="navbar__links">
          {links.map((l) => (
            <li key={l.label}>
              <a href={l.href} onClick={(e) => { e.preventDefault(); handleLink(l.href); }}>
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        <a
          href="#contact"
          className="btn-primary navbar__cta"
          onClick={(e) => { e.preventDefault(); handleLink('#contact'); }}
        >
          Book Free Consultation
        </a>

        {/* Hamburger */}
        <button
          className="navbar__hamburger"
          onClick={() => setOpen((p) => !p)}
          aria-label="Toggle menu"
        >
          {open ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            className="navbar__mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
          >
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={(e) => { e.preventDefault(); handleLink(l.href); }}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              className="btn-primary"
              style={{ marginTop: 8 }}
              onClick={(e) => { e.preventDefault(); handleLink('#contact'); }}
            >
              Book Free Consultation
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
}
